import { useCallback, useRef } from "react";
import type { KeyboardEvent } from "react";

/**
 * Esc com um `Menu` popup do Prime aberto dentro de um `Dialog`: o React fecha o menu (e solta o listener de Esc dele)
 * antes do listener global do documento, que então fecharia o `Dialog` também. A trava marca o Esc que o menu consumiu e
 * o retém antes do documento. Ligue `onShow` e `onHide` ao `Menu` e `onKeyDownCapture`/`onKeyDown` a um elemento que o
 * contenha na árvore do React (o painel sai em portal, mas os eventos sobem por ela).
 */
export function useEscFechaSoMenu() {
  const aberto = useRef(false);
  const escFechaMenu = useRef(false);

  const onShow = useCallback(() => {
    aberto.current = true;
  }, []);

  const onHide = useCallback(() => {
    aberto.current = false;
  }, []);

  const onKeyDownCapture = useCallback((event: KeyboardEvent<HTMLElement>) => {
    escFechaMenu.current = event.key === "Escape" && aberto.current;
  }, []);

  const onKeyDown = useCallback((event: KeyboardEvent<HTMLElement>) => {
    if (!escFechaMenu.current) return;
    escFechaMenu.current = false;
    if (!event.currentTarget.contains(event.target as Node)) event.stopPropagation();
  }, []);

  return { aberto, onShow, onHide, onKeyDownCapture, onKeyDown };
}
